import { MarketGroupDto } from './market-groups-api.model';

export const MARKET_GROUPS_STORAGE_KEY = 'kala-market-groups';

export function readStoredMarketGroups(): readonly MarketGroupDto[] {
	try {
		const stored = localStorage.getItem(MARKET_GROUPS_STORAGE_KEY);
		const parsed: unknown = stored === null ? null : JSON.parse(stored);

		return Array.isArray(parsed) ? (parsed as readonly MarketGroupDto[]) : [];
	} catch {
		return [];
	}
}

export function writeStoredMarketGroups(groups: readonly MarketGroupDto[]): void {
	try {
		localStorage.setItem(MARKET_GROUPS_STORAGE_KEY, JSON.stringify(groups));
	} catch {
		// Nothing to report: the answer this came from has already been applied to the running app.
	}
}
